(function () {
  var sections = document.querySelectorAll('[data-practical-guidance]');
  if (!sections.length) return;

  var isVisible = function (el) {
    return !!(el && (el.offsetWidth || el.offsetHeight || el.getClientRects().length));
  };

  var hardStop = function (video) {
    if (!video) return;
    if (!video.paused) video.pause();
    try {
      video.currentTime = 0;
    } catch (e) {
      /* ignore seek errors before metadata */
    }
  };

  var getVisibleVideos = function (root) {
    return Array.prototype.slice.call(root.querySelectorAll('video')).filter(isVisible);
  };

  sections.forEach(function (section) {
    var tabs = section.querySelectorAll('[data-tab-trigger]');
    var panes = section.querySelectorAll('[data-tab-pane]');
    var allVideos = Array.prototype.slice.call(section.querySelectorAll('video'));
    var allowedVideos = new Set();

    var stopAllVideos = function (exceptVideos) {
      exceptVideos = exceptVideos || [];
      allVideos.forEach(function (video) {
        if (exceptVideos.indexOf(video) !== -1) return;
        hardStop(video);
      });
    };

    // Only allow play while hovered/tapped; block theme/browser autoplay.
    allVideos.forEach(function (video) {
      video.muted = true;
      video.setAttribute('muted', '');
      video.playsInline = true;

      video.addEventListener('play', function () {
        if (!allowedVideos.has(video)) {
          hardStop(video);
        }
      });
    });

    stopAllVideos();

    // Step videos play one after another (step 1, 2, 3 ... then back to step 1),
    // one at a time, while their tab is open and on screen.
    panes.forEach(function (pane) {
      var cards = Array.prototype.slice.call(pane.querySelectorAll('[data-hover-media]'));
      if (!cards.length) return;

      var current = 0;
      var running = false;

      // Each card has a desktop and a mobile video; only one is visible.
      var videoOf = function (card) {
        return getVisibleVideos(card)[0] || null;
      };

      cards.forEach(function (card) {
        card.querySelectorAll('video').forEach(function (video) {
          video.loop = false;
          video.removeAttribute('loop');
        });
      });

      var playCurrent = function () {
        if (!running) return;
        var video = null;
        for (var i = 0; i < cards.length && !video; i++) {
          video = videoOf(cards[current]);
          if (!video) current = (current + 1) % cards.length;
        }
        if (!video) return;

        allowedVideos.clear();
        stopAllVideos([video]);
        allowedVideos.add(video);

        var playPromise = video.play();
        if (playPromise !== undefined && typeof playPromise.catch === 'function') {
          playPromise.catch(function () {
            /* blocked or interrupted: the next visibility change retries */
          });
        }
      };

      var advance = function () {
        current = (current + 1) % cards.length;
        playCurrent();
      };

      cards.forEach(function (card, index) {
        card.querySelectorAll('video').forEach(function (video) {
          video.addEventListener('ended', function () {
            if (index === current && allowedVideos.has(video)) advance();
          });
          // A video that fails to load must not stall the sequence.
          video.addEventListener('error', function () {
            if (index === current && running && isVisible(video)) advance();
          });
        });
      });

      var setRunning = function (next) {
        if (next === running) return;
        running = next;
        if (running) {
          playCurrent();
        } else {
          allowedVideos.clear();
          cards.forEach(function (card) {
            card.querySelectorAll('video').forEach(function (video) {
              if (!video.paused) video.pause();
            });
          });
        }
      };

      if ('IntersectionObserver' in window) {
        new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              setRunning(entry.isIntersecting);
            });
          },
          { threshold: 0.25 }
        ).observe(pane);
      } else {
        setRunning(true);
      }
    });

    var setActive = function (tabKey) {
      allowedVideos.clear();
      stopAllVideos();

      tabs.forEach(function (tab) {
        var isActive = tab.getAttribute('data-tab-trigger') === tabKey;
        tab.classList.toggle('is-active', isActive);
        tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });

      panes.forEach(function (pane) {
        var isActive = pane.getAttribute('data-tab-pane') === tabKey;
        pane.classList.toggle('is-active', isActive);
      });
    };

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        setActive(tab.getAttribute('data-tab-trigger'));
      });
    });

    // If a pane is hidden by class change from elsewhere, stop its videos.
    if (panes.length && window.MutationObserver) {
      var paneObserver = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          var pane = mutation.target;
          if (!pane.classList.contains('is-active')) {
            pane.querySelectorAll('video').forEach(function (video) {
              allowedVideos.delete(video);
              hardStop(video);
            });
          }
        });
      });

      panes.forEach(function (pane) {
        paneObserver.observe(pane, { attributes: true, attributeFilter: ['class'] });
      });
    }
  });

  // Step slider (desktop): arrows move the track one card at a time; smaller screens scroll natively.
  var initSlider = function (slider) {
    if (slider.getAttribute('data-dpg-ready') === 'true') return;
    slider.setAttribute('data-dpg-ready', 'true');

    var track = slider.querySelector('[data-dpg-track]');
    var viewport = slider.querySelector('.diagnox-practical-guidance__slider-viewport');
    var prev = slider.querySelector('[data-dpg-prev]');
    var next = slider.querySelector('[data-dpg-next]');
    var nav = slider.querySelector('.diagnox-practical-guidance__slider-nav');
    if (!track || !viewport) return;

    var index = 0;
    var lastView = 1;

    var gap = function () {
      var styles = window.getComputedStyle(track);
      return parseFloat(styles.columnGap || styles.gap) || 0;
    };

    var update = function (target) {
      if (!track.children[0]) return;

      // Cards are sized from the content width; the viewport itself reaches both edges of the
      // window, so the neighbouring cards peek out on either side while sliding.
      var wide = window.matchMedia('(min-width: 992px)').matches;
      var medium = window.matchMedia('(min-width: 750px)').matches;
      var oneCard = !!slider.closest('.diagnox-practical-guidance--one-card');
      var isResults = track.classList.contains('diagnox-practical-guidance__result-cards');
      var maxView = parseInt(window.getComputedStyle(track).getPropertyValue('--dpg-step-view'), 10) || 3;
      var view = wide ? maxView : medium ? Math.min(2, maxView) : (oneCard || isResults) ? 1 : Math.min(2, maxView);
      // The section has no right padding on mobile, so keep the page gutter on the right.
      var box = slider.getBoundingClientRect();
      var contentWidth = medium ? slider.clientWidth : Math.max(0, document.documentElement.clientWidth - box.left - 27);
      // Keep the arrows on the right edge of the content, not the edge of the window.
      if (nav) nav.style.marginRight = Math.max(0, box.right - box.left - contentWidth) + 'px';
      lastView = view;
      var cardWidth = (contentWidth - gap() * (view - 1)) / view;
      slider.style.setProperty('--dpg-card-w', cardWidth + 'px');

      var count = track.children.length;
      var isStatic = count <= view;
      slider.classList.toggle('is-static', isStatic);
      if (view === 1 && !medium) {
        // One card on mobile: clip at the page gutters so the neighbouring cards stay hidden.
        viewport.style.marginLeft = '';
        viewport.style.paddingLeft = '';
        viewport.style.marginRight = '';
        viewport.style.width = contentWidth + 'px';
      } else {
        viewport.style.width = '';
        var leftSpace = isStatic ? 0 : Math.max(0, box.left);
        var rightSpace = isStatic ? 0 : Math.max(0, document.documentElement.clientWidth - box.right);
        viewport.style.marginLeft = -leftSpace + 'px';
        viewport.style.paddingLeft = leftSpace + 'px';
        viewport.style.marginRight = -rightSpace + 'px';
      }

      var size = cardWidth + gap();
      var limit = Math.max(0, count * cardWidth + (count - 1) * gap() - contentWidth);
      var pages = isStatic ? 1 : Math.ceil((limit - 1) / size) + 1;
      index = Math.max(0, Math.min(target, pages - 1));
      var offset = isStatic ? 0 : Math.min(index * size, limit);
      track.style.transform = offset > 0 ? 'translateX(' + -offset + 'px)' : '';
      if (prev) prev.disabled = index === 0;
      if (next) next.disabled = index >= pages - 1;
    };

    if (next) next.addEventListener('click', function () { update(index + 1); });
    if (prev) prev.addEventListener('click', function () { update(index - 1); });
    window.addEventListener('resize', function () { update(index); });

    // The pane may be hidden (display: none) at load; measure again when the tab opens.
    if (window.ResizeObserver) {
      new ResizeObserver(function () { update(index); }).observe(viewport);
    }

    // While the step videos play one after another, slide the playing step into view.
    track.addEventListener('play', function (event) {
      var card = event.target.closest ? event.target.closest('.diagnox-practical-guidance__step-card') : null;
      if (!card) return;
      window.requestAnimationFrame(function () {
        if (event.target.paused) return;
        var position = Array.prototype.indexOf.call(track.children, card);
        if (position < 0) return;
        if (position < index) update(position);
        else if (position >= index + lastView) update(position - lastView + 1);
      });
    }, true);

    // Swipe left / right to slide.
    var startX = 0;
    var pressed = false;
    viewport.addEventListener('pointerdown', function (event) {
      if (event.pointerType === 'mouse') return;
      pressed = true;
      startX = event.clientX;
    });
    viewport.addEventListener('pointerup', function (event) {
      if (!pressed) return;
      pressed = false;
      var delta = event.clientX - startX;
      if (Math.abs(delta) >= 40) update(index + (delta < 0 ? 1 : -1));
    });
    viewport.addEventListener('pointercancel', function () { pressed = false; });

    update(0);
  };

  document.querySelectorAll('[data-dpg-slider]').forEach(initSlider);
  document.addEventListener('shopify:section:load', function (event) {
    event.target.querySelectorAll('[data-dpg-slider]').forEach(initSlider);
  });
})();
